var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"blur","mode":"out-in"}},[_c('router-view')],1),_c('modal-image-display'),_c('modal-barcode-display'),_c('vue-snotify',{class:_vm.toastStyle,attrs:{"width":"500"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }